export const desktopMenu = () => {
  $('.site-navigation .menu > li > a').click(function () {
    $(this).addClass('is-active');
    $(this).siblings('.sub-menu').addClass('is-open');
  });

  //dropdown

  $(document).click(function () {
    //alert('clicked outside');
    $('.sub-menu.is-open').removeClass('is-open');
  });

  $('.menu-item-has-children a[href="#"]').click(function (e) {
    e.preventDefault();
  });

  $('.menu-item-has-children a[href="#"], .sub-menu a').click(function (e) {
    e.stopPropagation();
  });
};
